import React, { createContext, useContext, useState, useEffect } from 'react';

// Translations
const translations = {
  pt: {
    // Navigation
    nav: {
      home: 'Início',
      about: 'Sobre mim',
      services: 'Momentos',
      culture: 'Cultura',
      mission: 'Missão',
      login: 'Entrar',
      dashboard: 'Dashboard',
      logout: 'Sair',
      book: 'Agendar',
    },
    // Home
    home: {
      hero_title: 'Revelando a beleza que existe',
      hero_title_accent: 'em você!',
      hero_subtitle: 'Aqui a sua história importa e a sua beleza é transformada',
      cta_book: 'Agendar momento',
      cta_discover: 'Veja como cuidamos de você',
      featured: 'Em Destaque',
      why_us: 'Porquê Lou\'s Way',
      why_us_1_title: 'Excelência',
      why_us_1_desc: 'Atendimento dedicado, realizado por uma profissional comprometida com qualidade, cuidado e atenção a cada detalhe.',
      why_us_2_title: 'Acolhimento',
      why_us_2_desc: 'Aqui você encontra escuta, conversa leve e um espaço seguro para se sentir à vontade — quase como uma terapia, onde cuidar da beleza também é cuidar de você.',
      why_us_3_title: 'Resultados',
      why_us_3_desc: 'Cuidados personalizados que realçam a beleza natural e proporcionam resultados harmoniosos e visíveis.',
    },
    // Services
    services: {
      title: 'Escolha sua transformação',
      subtitle: 'Cada momento é pensado para valorizar sua beleza real.',
      duration: 'Duração',
      minutes: 'minutos',
      book_now: 'Reservar Agora',
      view_details: 'Ver Detalhes',
      categories: {
        all: 'Todos',
        facial: 'Facial',
        massage: 'Massagem',
        skincare: 'Skincare',
        nails: 'Unhas',
        laser: 'Laser',
      },
    },
    // About
    about: {
      title: 'Sobre mim',
      subtitle: 'Uma história de paixão pela verdadeira beleza',
      story_title: 'Minha História',
      story_text: 'O Lou\'s Way nasceu do sonho de criar um espaço onde a beleza e a calmaria andam de mãos dadas.',
      team_title: 'Nossa Equipa',
      team_text: 'Profissionais dedicados e apaixonados por transformar vidas através da beleza.',
    },
    // Culture
    culture: {
      title: 'Nossa Cultura',
      subtitle: 'Valores que nos definem e guiam cada tratamento.',
      values: [
        { title: 'Excelência', desc: 'Buscamos a perfeição em cada detalhe.' },
        { title: 'Inovação', desc: 'Técnicas avançadas e tecnologia de ponta.' },
        { title: 'Cuidado', desc: 'Cada cliente é tratada com carinho e atenção.' },
        { title: 'Confiança', desc: 'Relações duradouras baseadas em transparência.' },
      ],
    },
    // Mission
    mission: {
      title: 'Missão e Valores',
      subtitle: 'O que nos move e inspira diariamente.',
      mission_title: 'Nossa Missão',
      mission_text: 'Revelar a melhor versão de cada cliente através do cuidado personalizado garantindo resultados que respeitam e enaltecem a identidade de cada um.',
      vision_title: 'Nossa Visão',
      vision_text: 'Inspirar a autoconfiança através de uma estética natural que respeita a individualidade e supera todas as expetativas.',
    },
    // Dashboard
    dashboard: {
      welcome: 'Bem-vinda(o)',
      my_bookings: 'Minhas Marcações',
      loyalty: 'Programa Fidelidade',
      points: 'pontos',
      frequent: 'Serviços Frequentes',
      history: 'Histórico',
      profile: 'Perfil',
      no_bookings: 'Ainda não tem marcações.',
      book_first: 'Agendar Momento',
      upcoming: 'Próximas',
      past: 'Anteriores',
      status: {
        pending: 'Pendente',
        confirmed: 'Confirmada',
        completed: 'Concluída',
        cancelled: 'Cancelada',
      },
      payment: {
        pending: 'Pagamento Pendente',
        paid: 'Pago',
        pay_now: 'Pagar Agora',
        pay_at_studio: 'Pagar no Estúdio',
      },
      cancel: 'Cancelar',
    },
    // Booking
    booking: {
      title: 'Marcação',
      select_service: 'Escolha o Serviço',
      select_staff: 'Escolha a Profissional',
      any_staff: 'Qualquer Profissional',
      select_date: 'Escolha a Data',
      select_time: 'Escolha o Horário',
      no_slots: 'Sem horários disponíveis',
      payment_method: 'Método de Pagamento',
      online: 'Pagar Online',
      in_person: 'Pagar no Estúdio',
      confirm: 'Confirmar Marcação',
      success: 'Marcação realizada com sucesso!',
      notes: 'Observações (opcional)',
    },
    // Admin
    admin: {
      title: 'Administração',
      dashboard: 'Painel',
      services: 'Serviços',
      team: 'Equipa',
      schedule: 'Horários',
      bookings: 'Marcações',
      content: 'Conteúdo',
      today_bookings: 'Marcações Hoje',
      today_revenue: 'Receita Hoje',
      total_clients: 'Total Clientes',
      pending: 'Pendentes',
      add_service: 'Adicionar Serviço',
      add_staff: 'Adicionar Colaborador',
      add_block: 'Bloquear Horário',
      block_reason: {
        lunch: 'Almoço',
        break: 'Pausa',
        absence: 'Ausência',
        holiday: 'Feriado',
      },
    },
    // Chat
    chat: {
      title: 'Louzinha',
      subtitle: 'Assistente Virtual',
      placeholder: 'Escreva sua mensagem...',
      greeting: 'Olá! Sou a Louzinha, sua assistente virtual. Como posso ajudá-la hoje?',
    },
    // Common
    common: {
      loading: 'A carregar...',
      error: 'Ocorreu um erro',
      save: 'Guardar',
      cancel: 'Cancelar',
      delete: 'Eliminar',
      edit: 'Editar',
      close: 'Fechar',
      search: 'Pesquisar',
      filter: 'Filtrar',
      view_all: 'Ver Todas',
      back: 'Voltar',
      next: 'Próximo',
      previous: 'Anterior',
      confirm: 'Confirmar',
      success: 'Sucesso',
      language: 'Idioma',
    },
    // Footer
    footer: {
      rights: 'Todos os direitos reservados.',
      contact: 'Contacto',
      hours: 'Horário',
      hours_text: 'Seg-Sáb: 08h - 20h',
      address: 'Morada',
      follow: 'Siga-nos',
    },
  },
  en: {
    // Navigation
    nav: {
      home: 'Home',
      about: 'About me',
      services: 'Services',
      culture: 'Culture',
      mission: 'Mission',
      login: 'Login',
      dashboard: 'Dashboard',
      logout: 'Logout',
      book: 'Book Now',
    },
    // Home
    home: {
      hero_title: 'Revealing the beauty',
      hero_title_accent: 'within you!',
      hero_subtitle: 'Here, your story matters and your beauty is transformed.',
      cta_book: 'Book Appointment',
      cta_discover: 'Discover Services',
      featured: 'Featured Services',
      why_us: 'Why Lou\'s Way',
      why_us_1_title: 'Excellence',
      why_us_1_desc: 'Dedicated service provided by a professional committed to quality, care, and attention to every detail.',
      why_us_2_title: 'Reception',
      why_us_2_desc: 'Here you will find someone to listen to you, light conversation, and a safe space to feel at ease—almost like therapy, where taking care of your beauty is also taking care of yourself.',
      why_us_3_title: 'Results',
      why_us_3_desc: 'Personalized care that enhances natural beauty and provides harmonious, visible results.',
    },
    // Services
    services: {
      title: 'Our Services',
      subtitle: 'Discover exclusive treatments to enhance your natural beauty.',
      duration: 'Duration',
      minutes: 'minutes',
      book_now: 'Book Now',
      view_details: 'View Details',
      categories: {
        all: 'All',
        facial: 'Facial',
        massage: 'Massage',
        skincare: 'Skincare',
        nails: 'Nails',
        laser: 'Laser',
      },
    },
    // About
    about: {
      title: 'About Us',
      subtitle: 'A story of passion for true beauty.',
      story_title: 'My Story',
      story_text: 'Lou\'s Way was born from the dream of creating a space where beauty and calm go hand in hand.',
      team_title: 'Our Team',
      team_text: 'Dedicated professionals passionate about transforming lives through beauty.',
    },
    // Culture
    culture: {
      title: 'Our Culture',
      subtitle: 'Values that define us and guide every treatment.',
      values: [
        { title: 'Excellence', desc: 'We seek perfection in every detail.' },
        { title: 'Innovation', desc: 'Advanced techniques and cutting-edge technology.' },
        { title: 'Care', desc: 'Each client is treated with love and attention.' },
        { title: 'Trust', desc: 'Lasting relationships based on transparency.' },
      ],
    },
    // Mission
    mission: {
      title: 'Mission & Values',
      subtitle: 'What moves and inspires us daily.',
      mission_title: 'My Mission',
      mission_text: 'Revealing the best version of each client through personalized care, ensuring results that respect and enhance each individual\'s identity.',
      vision_title: 'My Vision',
      vision_text: 'Inspiring self-confidence through natural aesthetics that respect individuality and exceed all expectations.',
    },
    // Dashboard
    dashboard: {
      welcome: 'Welcome',
      my_bookings: 'My Bookings',
      loyalty: 'Loyalty Program',
      points: 'points',
      frequent: 'Frequent Services',
      history: 'History',
      profile: 'Profile',
      no_bookings: 'No bookings yet.',
      book_first: 'Book Your First Appointment',
      upcoming: 'Upcoming',
      past: 'Past',
      status: {
        pending: 'Pending',
        confirmed: 'Confirmed',
        completed: 'Completed',
        cancelled: 'Cancelled',
      },
      payment: {
        pending: 'Payment Pending',
        paid: 'Paid',
        pay_now: 'Pay Now',
        pay_at_studio: 'Pay at Studio',
      },
      cancel: 'Cancel',
    },
    // Booking
    booking: {
      title: 'Book Service',
      select_service: 'Choose Service',
      select_staff: 'Choose Professional',
      any_staff: 'Any Professional',
      select_date: 'Choose Date',
      select_time: 'Choose Time',
      no_slots: 'No available slots',
      payment_method: 'Payment Method',
      online: 'Pay Online',
      in_person: 'Pay at Studio',
      confirm: 'Confirm Booking',
      success: 'Booking successful!',
      notes: 'Notes (optional)',
    },
    // Admin
    admin: {
      title: 'Administration',
      dashboard: 'Dashboard',
      services: 'Services',
      team: 'Team',
      schedule: 'Schedule',
      bookings: 'Bookings',
      content: 'Content',
      today_bookings: 'Today\'s Bookings',
      today_revenue: 'Today\'s Revenue',
      total_clients: 'Total Clients',
      pending: 'Pending',
      add_service: 'Add Service',
      add_staff: 'Add Staff',
      add_block: 'Block Time',
      block_reason: {
        lunch: 'Lunch',
        break: 'Break',
        absence: 'Absence',
        holiday: 'Holiday',
      },
    },
    // Chat
    chat: {
      title: 'Louzinha',
      subtitle: 'Virtual Assistant',
      placeholder: 'Type your message...',
      greeting: 'Hello! I\'m Louzinha, your virtual assistant. How can I help you today?',
    },
    // Common
    common: {
      loading: 'Loading...',
      error: 'An error occurred',
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      close: 'Close',
      search: 'Search',
      filter: 'Filter',
      view_all: 'View All',
      back: 'Back',
      next: 'Next',
      previous: 'Previous',
      confirm: 'Confirm',
      success: 'Success',
      language: 'Language',
    },
    // Footer
    footer: {
      rights: 'All rights reserved.',
      contact: 'Contact',
      hours: 'Hours',
      hours_text: 'Mon-Sat: 08am - 8pm',
      address: 'Address',
      follow: 'Follow Us',
    },
  },
};

// Context
const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    if (typeof window !== 'undefined') {
      return localStorage.getItem('lou_language') || 'pt';
    }
    return 'pt';
  });

  useEffect(() => {
    localStorage.setItem('lou_language', language);
  }, [language]);

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'pt' ? 'en' : 'pt');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default translations;
